import { gql } from "@apollo/client";

export const GET_AUDIT_TRAIL_DELIVERY = gql`
  query GetAuditTrailDelivery($key: String!) {
    auditTrailWebhook {
      endpoint
      deliveryDetails(key: $key) {
        requestHeaders {
          name
          values
        }
        requestBody
        responseHeaders {
          name
          values
        }
        responseError
        responseBody
      }
    }
  }
`;

export const GET_STACK_WEBHOOK_DELIVERY_DETAILS = gql`
  query GetWebhookDeliveryByStack($key: String!, $id: ID!, $stack: ID!) {
    stack(id: $stack) {
      id
      integrations {
        webhook(id: $id) {
          id
          deliveryDetails(key: $key) {
            requestHeaders {
              name
              values
            }
            requestBody
            responseHeaders {
              name
              values
            }
            responseError
            responseBody
          }
        }
      }
    }
  }
`;
